import { useRouter } from 'next/router'

import GET_GROUP_FILTERS from '@/graphql/queries/global/getGroupFilter'
import GET_GROUP_HIGHEST_PRICE from '@/graphql/queries/products/getGroupHighestPrice'
import GET_GROUP_PRODUCTS from '@/graphql/queries/products/getGroupProducts'
import useHasura from '@/hooks/useHasura'
import usePagination from '@/hooks/usePagination'
import usePriceRange from '@/hooks/usePriceRange'
import Filters from '@/services/Filters/Filters'
import { ProductTypeAsTitleMap } from '@/ts/enums/product/ProductType'
import { Aggregate } from '@/ts/Global'
import FilterGroup from '@/ts/interfaces/global/FilterGroup'
import Product, { ProductType } from '@/ts/Product'

function useGroupFilters() {
  const {
    query: { slug },
  } = useRouter()

  const currentFilters = Filters.get() || {}
  const priceRange = usePriceRange(100)

  const variables = { ...currentFilters, ...priceRange }

  const filtersQuery = useHasura<FilterGroup>('filters', GET_GROUP_FILTERS, {
    variables: {
      slug,
    },
  })

  const queryPrice = useHasura<{ prices: any; total: Aggregate }>(
    'products_highest_price',
    GET_GROUP_HIGHEST_PRICE,
    { variables: { slug, ...variables } }
  )

  const maxPrice = Number(queryPrice?.data?.prices?.[0]?.value) || 0
  const total = Number(queryPrice?.data?.total?.aggregate?.count) || 0

  const filters = filtersQuery.data
  // const creators = collectionCreatorsQuery?.data?.creators

  const { limit, offset } = usePagination(total)
  const { data: products } = useHasura<{ products?: Product[] }>(
    'products',
    GET_GROUP_PRODUCTS,
    {
      variables: { ...variables, limit, offset, slug },
    }
  )

  return {
    filters: {
      ...filters,
      ...(filters?.type && {
        type: filters.type?.map(({ id }) => ({
          id,
          name: ProductTypeAsTitleMap[id as ProductType],
        })),
      }),
    },
    maxPrice,
    total,
    products: products?.products,
    // creators,
  }
}

export default useGroupFilters
